const { default: Swiper } = require('swiper');
const { EffectFade, Navigation, Pagination } = require('swiper/modules');
const {
    swiperNavigation,
    swiperPagination,
} = require('../modules/swiperModules');
const { GoogleMaps } = require('../components/GoogleMaps');

const sections = document.querySelectorAll('section.text-image');

if (sections.length) {
    sections.forEach(element => {
        const swiperEl = element.querySelector('.swiper');
        const map = element.querySelector('[js-text-image-map]');
        if (swiperEl) {
            const arrowsEl = element.querySelector('.slider-arrows');
            const paginationElement =
                element.querySelector('.slider-pagination');

            let args = {
                modules: [EffectFade, Navigation, Pagination],
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
            };
            if (arrowsEl) {
                args = { ...args, ...swiperNavigation(arrowsEl) };
            }

            if (paginationElement) {
                args = { ...args, ...swiperPagination(paginationElement) };
            }

            const swiper = new Swiper(swiperEl, args);
        }

        if (map) {
            const googleMap = new GoogleMaps(map);
            const points = JSON.parse(map.getAttribute('data-point'));
            googleMap.initMap(points[0].id);
        }
    });
}
